import { render, staticRenderFns } from "./TeamVisibilityDropdown.vue?vue&type=template&id=a0d070ac&scoped=true&"
import script from "./TeamVisibilityDropdown.vue?vue&type=script&lang=js&"
export * from "./TeamVisibilityDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0d070ac",
  null
  
)

export default component.exports